import { tableHelper } from "@/helpers/table.helper";
import { getBlankRecord } from "./helpers";
import * as mutation from "./mutation-types";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      levyCollectionId: null,
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      expanded: [],
      paging: tableHelper.getDefaultPaging("Provider.Name", false),
      loading: false,
      loaded: false
    },
    edit: {
      data: getBlankRecord(),
      loading: false,
      saving: false,
      isNew: true,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    delete: {
      processing: false
    },
    candidatesForCopying: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: []
    },
    copy: {
      processing: false
    },
    all: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: []
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    candidatesForCopying: {
      loaded: false
    },
    all: {
      loaded: false
    }
  };
}
